/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import { withTransaction } from '@elastic/apm-rum-react'

import type { ElasticsearchCluster, StackDeployment } from '@modules/ui-types'

import { getStackDeployment } from '@/reducers/stackDeployments'
import { getCluster } from '@/reducers/clusters'

import { withStackDeploymentRouteParams } from '../StackDeploymentEditor'

import DeploymentSecurity from './DeploymentSecurity'

import type { ReduxState } from '@/types/redux'
import type { WithStackDeploymentRouteParamsProps } from '../StackDeploymentEditor'

type StateProps = {
  cluster?: ElasticsearchCluster | null
  deployment: StackDeployment | undefined
}

type ConsumerProps = WithStackDeploymentRouteParamsProps

const mapStateToProps = (
  state: ReduxState,
  { regionId, deploymentId, stackDeploymentId }: ConsumerProps,
): StateProps => ({
  cluster: getCluster(state, regionId, deploymentId!),
  deployment: getStackDeployment(state, stackDeploymentId),
})

export default withStackDeploymentRouteParams(
  connect<StateProps, ConsumerProps>(mapStateToProps)(
    withTransaction(`Deployment security`, `component`)(DeploymentSecurity),
  ),
)
